import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { PlanoAcao } from '../../models/plano-acao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAtividadeService } from '../../services/indicadores-atividade.service';
import { IndicadoresPgAtividadeService } from '../../services/indicadores-pg-atividade.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PlanoAcaoService } from '../../services/plano-acao.service';
@Component({
  selector: 'app-detalhe-projeto-plano-acao-edit',
  templateUrl: './detalhe-projeto-plano-acao-edit.component.html',
  styleUrls: ['./detalhe-projeto-plano-acao-edit.component.scss']
})
export class DetalheProjetoPlanoAcaoEditComponent extends BaseFormComponent<PlanoAcao> implements OnInit {

  idProjeto: number;
  idEntrega: number;
  idIndicador: number;
  idPgIndicador: number;
  isIndicador: boolean;
  isPgIndicador: boolean;
  pgType: string;
  planoAcao: PlanoAcao;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Nova';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private planoAcaoService: PlanoAcaoService,
    private atividadeService: IndicadoresAtividadeService,
    private pgAtividadeService: IndicadoresPgAtividadeService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });

    this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
    this.list = this.activatedRoute.snapshot.data['list'];
    this.pgType = this.activatedRoute.snapshot.data['type'];
    if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['prt_issue_id']) {
      this.idEntrega = this.activatedRoute.snapshot.queryParams['prt_issue_id'];
    } else if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['ind_id']) {
      this.idIndicador = this.activatedRoute.snapshot.queryParams['ind_id'];
    } else if (!this.entity?.id && this.activatedRoute.snapshot.queryParams['pg_ind_id']) {
      this.idPgIndicador = this.activatedRoute.snapshot.queryParams['pg_ind_id'];
    }

    this.isIndicador = this.activatedRoute.snapshot.data['isIndicador'];
    this.isPgIndicador = this.activatedRoute.snapshot.data['isPgIndicador'];

    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      dt_start: new FormControl(null, [Validators.required]),
      deadline: new FormControl(null, [Validators.required]),
      manager: new FormControl(null, [Validators.required]),
      adjunct: new FormControl(null),
      prt_issue_action_stat_id: new FormControl(null, this.idEntrega || this.entity?.prt_issue_id ? [Validators.required] : []),
      prt_issue_id: new FormControl(this.idEntrega, this.idEntrega ? [Validators.required] : []),
      ind_action_stat: new FormControl(null, this.idIndicador || this.entity?.ind_id ? [Validators.required] : []),
      ind_id: new FormControl(this.idIndicador, this.idIndicador ? [Validators.required] : []),
      pg_ind_id: new FormControl(this.idPgIndicador, this.idPgIndicador ? [Validators.required] : []),
      extras: new FormArray([]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.entity?.extras?.forEach((item) => {
        item.decimal_places = String(item?.decimal_places);
        this.getFormArray().push(this.createFormGroup(item))
      })

      if (this.idEntrega || this.entity?.prt_issue_id) {
        // plano de ação de entregas
        this.audit = {
          prt_issue_action_id: this.entity.id
        };
      } else {
        // atividade (plano de ação) de indicadores de projetos e de agregadores
        this.audit = {
          ind_action_id: this.entity.id
        };
      }
    }
  }

  typeStatusForm(): string {
    return this.idEntrega || this.entity?.prt_issue_id ? 'prt_issue_action_stat_id' : 'ind_action_stat'
  }

  createFormGroup(values = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      title: new FormControl(values?.title, [Validators.required]),
      unit_id: new FormControl(values?.unit_id, [Validators.required]),
      decimal_places: new FormControl(values?.decimal_places, [Validators.required]),
      goal: new FormControl(values?.goal),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('extras') as FormArray;
  }

  addMedida() {
    this.getFormArray().push(this.createFormGroup());
  }

  removeMedida(index: number) {
    this.getFormArray().removeAt(index);
  }

  voltar() {    
    if (this.entity?.prt_issue_id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'plano-acao', this.entity?.id]);
    } else if (this.idEntrega) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega]);
    } else if (this.entity?.ind_id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'atividade', this.entity?.id]);
    } else if (this.idIndicador) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador]);
    } else if (this.idPgIndicador) {
      this.navigation.back(['projetos', this.pgType ?? 'agregador', 'indicadores', this.idPgIndicador]);
    } else if (this.entity?.pg_ind_id) {
      this.navigation.back(['projetos', this.pgType ?? 'agregador', 'indicadores', this.entity?.pg_ind_id]);
    } else {
      this.navigation.back();
    }
  }

  getDataCreate(): PlanoAcao {
    let data: PlanoAcao;
    data = Object.assign({}, data, this.form.value);

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!formatoDataRegex.test(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    }
    if (!formatoDataRegex.test(data.deadline)) {
      data.deadline = formatDate(data.deadline, 'DD/MM/YYYY');
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_start', 'deadline')) {
      this.loading();
      
      if (this.idEntrega || this.entity?.prt_issue_id) {
        if (this.entity?.id) {
          this.addSub(
            this.planoAcaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Ação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.planoAcaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'plano-acao', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      } else if (this.idIndicador || this.entity?.ind_id) {
        if (this.entity?.id) {
          this.addSub(
            this.atividadeService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Atividade alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.atividadeService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'atividade', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      } else if (this.idPgIndicador || this.entity?.pg_ind_id) {
        if (this.entity?.id) {
          this.addSub(
            this.pgAtividadeService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Atividade alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else {
          this.addSub(
            this.pgAtividadeService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', this.pgType ?? 'agregador', 'atividade', res.id, 'editar']);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      }
    }
    else {
      this.markAsDirty();
      this.getFormArray().controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
      })
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formatarMedidaFisica(index: number) {
    let goalValue = this.getFormArray().controls[index].get('goal')?.value;
    let decimalPlacesValue = this.getFormArray().controls[index].get('decimal_places')?.value;
    let value = this.maskService.formatarMedidaFisica(goalValue, decimalPlacesValue);
    this.getFormArray().controls[index].get('goal').setValue(value);
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    if (this.isIndicador) {
      this.atividadeService.delete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.isPgIndicador) {
      this.pgAtividadeService.delete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else {
      this.planoAcaoService.delete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    }
  }
}
